import { render } from "./MetricsViewer.vue?vue&type=template&id=b728f982&ts=true"
import script from "./MetricsViewer.vue?vue&type=script&lang=ts"
export * from "./MetricsViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src678506843/src/babyhead-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__